import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { MadisonFile } from '../../types';
import { TableHeader } from '../TableHeader';

interface PropTypes {
  madisonFiles: MadisonFile[];
}

const TableRow = ({ madisonFile }: { madisonFile: MadisonFile }) => (
  <Table.Row>
    <Table.Cell collapsing>
      <a href={`archived-madison-order-documents/${madisonFile.number}`} target="blank">
        <b>{madisonFile.number}</b>
      </a>
    </Table.Cell>
    <Table.Cell collapsing>{madisonFile.receivedDate}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.address}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.city}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.zip}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.county}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.section}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.block}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.lots}</Table.Cell>
    <Table.Cell collapsing>{madisonFile.description}</Table.Cell>
  </Table.Row>
);

const MadisonFilesTab = (props: PropTypes) => {
  const [sortedMadisonFiles, setSortedMadisonFiles] = useState<MadisonFile[]>([]);

  useEffect(() => {
    if (props.madisonFiles) {
      setSortedMadisonFiles(props.madisonFiles);
    }
  }, [props.madisonFiles]);
  return (
    <React.Fragment>
      {sortedMadisonFiles.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={10} sortable>
          <TableHeader
            columnNames={[
              'Order Number',
              'Received Date',
              'Address',
              'City',
              'Zip',
              'County',
              'Section',
              'Block',
              'Lots',
              'Description',
            ]}
            sortedData={sortedMadisonFiles}
            setSortedData={setSortedMadisonFiles}
          />
          <Table.Body>
            {sortedMadisonFiles.map(mf => (
              <TableRow madisonFile={mf} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};
export default MadisonFilesTab;
